import React, { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import {
  ModalBase,
  ModalWrapper,
  ModalFooterButtons,
  ModalBodyCustomColumns,
} from './ModalComponents';
import { useCancelOfferMutation } from '../../hooks';
import { enqueueSnackbar } from '../snackbar';
import { BorderLine } from '../border-line';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';
import { useIsSmallScreen } from '../../hooks';

interface OfferCancelModalType {
  data: {
    id: string;
    number: string;
    price: number;
  }[];
  submitClick: () => void;
  open: () => void;
}

export const offerCancelModal: OfferCancelModalType = {
  data: [],
  submitClick: () => null,
  open: () => null,
};

export const OfferCancelModal = () => {
  const { mutate } = useCancelOfferMutation();
  const isSmallScreen = useIsSmallScreen();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    offerCancelModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    offerCancelModal.data = [];
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      offerCancelModal.data.map((item) => ({
        id: item.id,
      })),
      {
        onSuccess: () => {
          setOpen(false);
          offerCancelModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.OFFER.ERROR.NOT_CANCELLED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase
      id={'offer-delete-modal'}
      paperSize={isSmallScreen ? 'mobile' : 'default'}
      open={open}
      onClose={handleOnClose}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.offerCancelTitle', {
            count: offerCancelModal.data.length,
            total: offerCancelModal.data.reduce((acc, item) => acc + Number(item.price), 0),
          })}
        </Typography>
        <ModalBodyCustomColumns columns={'1fr'}>
          {offerCancelModal.data.map((item, i) => (
            <React.Fragment key={i}>
              {i !== 0 && <BorderLine space={'none'} />}
              <ModalBodyCustomColumns columns={'1fr max-content'}>
                <Typography variant={'textM'}>{item.number}</Typography>
                <Typography variant={'textM'}>{item.price}$</Typography>
              </ModalBodyCustomColumns>
            </React.Fragment>
          ))}
        </ModalBodyCustomColumns>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'destructive'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
